import { ProductTypeType } from "@/types/graphql/site.generated";
import { formatCurrency, getPeriodLabel } from "@/shared/utils";

type Translate = (key: string, options?: Record<string, unknown>) => string;

export interface PriceForLabels {
  /** Первое списание (у промокода DISCOUNT уже со скидкой). */
  value: number;
  /** Цена регулярного цикла подписки; null у PPV и у старого ответа сервера. */
  renewValue?: number | null;
  currency: string;
  period: number;
}

/**
 * Подписи цены для диалога оплаты. У подписки обе подписи по цене
 * продления: промокод (в том числе на 100%) и триал действуют только на
 * первый платёж, его сумму диалог берёт у сервера (createPayment.amount) и
 * показывает отдельной строкой «Первое списание», когда она отличается.
 * Пока сервер не ответил, та же подпись продления стоит на кнопке.
 * Живой прогон 2026-10-14: со скидкой 100% строка «продлевается
 * автоматически» показывала $0 / месяц.
 */
export function subscriptionPriceLabels(
  t: Translate,
  type: ProductTypeType | string,
  price: PriceForLabels,
): { amountLabel: string; priceOnPeriod: string | null } {
  if (type !== ProductTypeType.SubscriptionType) {
    return {
      amountLabel: formatCurrency(price.value, price.currency),
      priceOnPeriod: null,
    };
  }
  const renewLabel = formatCurrency(
    price.renewValue ?? price.value,
    price.currency,
  );
  return {
    amountLabel: renewLabel,
    priceOnPeriod: `${renewLabel} / ${getPeriodLabel(t, type, price.period).toLowerCase()}`,
  };
}
